"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: ()=>_arrayWithHoles
});
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
